/* eslint-disable @typescript-eslint/no-explicit-any */
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'language'
})
export class LanguagePipe implements PipeTransform {
  returnVariable = '';

  transform(value: any, args?: any): any {
    // Fallback if args or required parameters are missing
    if (!args || !args[0] || !args[2]) {
      return value || '';
    }

    let keys: any = Object.keys(args[0]);
    keys = keys.filter((el: any) => el.includes(args[2]));

    // If no matching keys found, return the original value or empty string
    if (keys.length === 0) {
      return value || '';
    }

    if (args[1] === 'en') {
      keys = keys.filter((el: any) => {
        if (el.includes('_ar')) {
          return false;
        } else {
          return true;
        }
      });
      // Use keys[0] instead of keys array
      this.returnVariable = keys.length > 0 ? args[0][keys[0]] : (value || '');
    } else if (args[1] === 'ar') {
      keys = keys.filter((el: any) => {
        if (el.includes('_ar')) {
          return true;
        } else {
          return false;
        }
      });
      // Use keys[0] instead of keys array
      this.returnVariable = keys.length > 0 ? args[0][keys[0]] : (value || '');
    } else {
      // Fallback for unknown language
      this.returnVariable = keys.length > 0 ? args[0][keys[0]] : (value || '');
    }
    
    return this.returnVariable || '';
  }
}
